import React, { Component, RefObject } from 'react';
import { connect } from 'react-redux';
import {SignaturePad} from '@creatdevsolutions/cs-react-signature-pad';

import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';
import ResponseError from '../../../models/ResponseError';
import DriverSignature from './DriverSignature';
import signatureRequestHandler from '../../../api/signatureRemote';
import offlineRfsRemote from '../../../api/offlineRfsRemote';
import ApiResponse from '../../../models/ApiResponse';
import poRequestHandler from '../../../api/pickupOrderRemote';
import PickupOrder from '../../../models/PickupOrder';
import { OfflineRfsOrder } from '../../../models/OfflineRfs';
import PickupOrderListItem from '../../../models/PickupOrderListItem';
import { OrderLockStatusType } from '../../../models/OrderLockStatusType.enum';

interface DriverSignatureProps {
  match: { params: { number: string, awbCode?: string, awbNumber?: string, awbVersion: string } };
  type: 'po' | 'do' | 'rfs' | 'go';
  return: boolean;
  receiveError: Function;
  receiveSuccess: Function;
};
  
interface DriverSignatureState {
  signaturePadRef: RefObject<SignaturePad>,
  hasSignatureInPad: boolean,
  savedSignatureUrl: string,
  driverName: string,
  signaturePadWidth: number,
  signaturePadHeight: number,
  signatureError: boolean,
  order: { 
    lock_status: string,
    gha_wh_user_name: string
  },
  goodsValue: boolean;
  remarksText: string;
};

class DriverSignatureContainer extends Component<DriverSignatureProps, DriverSignatureState> {

  state = {
    signaturePadRef: React.createRef<SignaturePad>(),
    hasSignatureInPad: false,
    savedSignatureUrl: '',
    driverName: '',
    signaturePadWidth: 0,
    signaturePadHeight: 0,
    signatureError: false,
    order: {
      lock_status: 'unlocked',
      gha_wh_user_name: ''
    },
    goodsValue: false,
    remarksText: ''
  }

  componentDidMount() {
    this.resizeCanvas();
    if(this.props.type !== 'rfs') {
      this.getGoodsValue();
    }
    window.addEventListener("resize", this.resizeCanvas);
    this.loadPickupOrder();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeCanvas);
    if(!this.state.savedSignatureUrl) {
      this.doLockPickupOrder();
    }
  }

  resizeCanvas = (): void => {
    let canvasWidth: number = window.screen.width - 100;
    let canvasHeight: number = window.screen.height - 200;
    
    if (canvasHeight > 200) {
      canvasHeight = 200;
    }
    this.setState({
      signaturePadWidth: canvasWidth,
      signaturePadHeight: canvasHeight
    }, () =>{
      if (this.state.signaturePadRef.current) {
        this.state.signaturePadRef.current._resizeCanvas();
      }
    });
  }

  doLockPickupOrder = (): void => {

    const locked: boolean = this.state.order.lock_status === OrderLockStatusType.UNLOCKED;
    const number: string = this.props.match.params.number;

    if((this.props.type === 'po' || this.props.type === 'do' || this.props.type === 'go') && number) {

      poRequestHandler.doGhaWhPoLock(number, locked).then((resp: ApiResponse<{ lock_status: string; gha_wh_user_name: string; }>) => {

        const updateValues: { lock_status: string; gha_wh_user_name: string; } | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (updateValues) {
          const order = { ...this.state.order };

          order.lock_status = updateValues.lock_status;
          order.gha_wh_user_name = updateValues.gha_wh_user_name;

          this.setState({ order });
        }
    
        if (error) {
          this.props.receiveError(error);
        };
      });
    }

    if(this.props.type === 'rfs') {

      offlineRfsRemote.doGhaWhPoLock(parseInt(number), locked).then((resp: ApiResponse<{ lock_status: string; gha_wh_user_name: string; }>) => {

        const updateValues: { lock_status: string; gha_wh_user_name: string; } | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (updateValues) {
          const order = { ...this.state.order };

          order.lock_status = updateValues.lock_status;
          order.gha_wh_user_name = updateValues.gha_wh_user_name;

          this.setState({ order });
        }
    
        if (error) {
          this.props.receiveError(error);
        };
      });
    }
  }

  getGoodsValue = (): void => {
    const poNumber: string = this.props.match.params.number;
    poRequestHandler.getGoodsDeclaration(poNumber).then((resp: ApiResponse<{dangerous_goods: boolean}>) => {
      const value: { dangerous_goods: boolean } | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (value) {
        this.setState({ goodsValue: value.dangerous_goods });
      }
  
      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  updateGoodsValue = (): void => {
    const poNumber: string = this.props.match.params.number;
    const goodsValue: boolean = this.state.goodsValue;
    poRequestHandler.updateGoodsDeclaration(poNumber, { value: !goodsValue }).then((resp: ApiResponse<boolean>) => {
      const value: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (value) {
        this.setState({ goodsValue: !goodsValue });
      }
  
      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  loadPickupOrder = (): void => {
    const poNumber: string = this.props.match.params.number;

      if(this.props.type === 'po' || this.props.type === 'do' || this.props.type === 'go') {

      poRequestHandler.getPickupOrder(poNumber).then((resp:ApiResponse<PickupOrder>) => {
        const po: PickupOrder | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (po) {
          const savedSignatureUrl: string = signatureRequestHandler.constructSignatureUrl(poNumber, {
            code: this.props.match.params.awbCode, number: this.props.match.params.awbNumber
          });
          if (po.driver_signature_key) {
            this.setState({ savedSignatureUrl });
          } else {
            if(this.props.match.params.awbCode) {
              let poAwb: PickupOrderListItem = po.list.find((awb: PickupOrderListItem) => {
                return awb.code === this.props.match.params.awbCode && awb.number === this.props.match.params.awbNumber;
              }) as PickupOrderListItem;
              if(poAwb.note) {
                this.setState({ remarksText: poAwb.note });
              }
              if(poAwb.returned) {
                this.setState({ savedSignatureUrl });
              }
            } else {
              if(po.fully_returned)
                this.setState({ savedSignatureUrl });
            }
          }
          this.setState({driverName: po.driver_name });
          if(!this.state.savedSignatureUrl) {
            this.doLockPickupOrder();
          }
        }
        
        if (error) {
          this.props.receiveError(error);
        };
      });
    }

    if(this.props.type === 'rfs') {

      offlineRfsRemote.getOfflineRfsOrderDetails(parseInt(poNumber)).then((resp: ApiResponse<OfflineRfsOrder>) => {

        const po: OfflineRfsOrder | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (po) {
          const savedSignatureUrl: string = signatureRequestHandler.constructOfflineSignatureUrl(parseInt(poNumber), {
            code: this.props.match.params.awbCode, number: this.props.match.params.awbNumber
          });
          if (po.driver_signature_key) {
            this.setState({ savedSignatureUrl });
          }
          this.setState({driverName: po.driver_name });
          if(!this.state.savedSignatureUrl) {
            this.doLockPickupOrder();
          }
        }
        
        if (error) {
          this.props.receiveError(error);
        };
      });
    }
  }

  saveSignature = (): void => {
    if (this.props.return && !this.state.remarksText) {
      return;
    }
    if (this.state.signaturePadRef.current && !this.state.signaturePadRef.current.isEmpty()) {
      const poNumber: string = this.props.match.params.number;
      const signature: string = this.state.signaturePadRef.current.toDataURL('image/png', 0.92);

        if(this.props.type === 'po' || this.props.type === 'do' || this.props.type === 'go') {

        signatureRequestHandler.saveSignature(poNumber, signature, this.props.return, {
          code: this.props.match.params.awbCode, number: this.props.match.params.awbNumber, version: this.props.match.params.awbVersion
        }, this.props.type, this.state.remarksText).then((resp: ApiResponse<boolean>) => {
          const success: boolean | undefined = resp.success;
          const error: ResponseError | undefined = resp.error;
    
          if (success) {
            this.props.receiveSuccess('The signature has been successfully saved!');
            const savedSignatureUrl:string = signatureRequestHandler.constructSignatureUrl(poNumber, {
              code: this.props.match.params.awbCode, number: this.props.match.params.awbNumber
            });
            this.setState({ savedSignatureUrl });
          }
          
          if (error) {
            this.props.receiveError(error);
          };
        });
      }

      if(this.props.type === 'rfs') { 

        signatureRequestHandler.saveOfflineSignature(poNumber, signature, this.props.return, {
          code: this.props.match.params.awbCode, number: this.props.match.params.awbNumber
        }).then((resp: ApiResponse<boolean>) => {
          const success: boolean | undefined = resp.success;
          const error: ResponseError | undefined = resp.error;
    
          if (success) {
            this.props.receiveSuccess('The signature has been successfully saved!');
            const savedSignatureUrl:string = signatureRequestHandler.constructOfflineSignatureUrl(parseInt(poNumber), {
              code: this.props.match.params.awbCode, number: this.props.match.params.awbNumber
            });
            this.setState({ savedSignatureUrl });
          }
          
          if (error) {
            this.props.receiveError(error);
          };
        });
      }
    }
  }

  clearSignature = (): void => {
    if (this.state.signaturePadRef.current) {
      this.state.signaturePadRef.current.clear();
      this.setState({hasSignatureInPad: false});
    }
  }


  isDisabledSave = (type: string): boolean => {
    if (type === 'save' && this.props.return && !this.state.remarksText && this.state.hasSignatureInPad && !this.state.savedSignatureUrl) {
      return true;
    }
    if (this.state.hasSignatureInPad && !this.state.savedSignatureUrl) {
      return false;
    }
    return true;
  }

  handleRemarksChange = (e: any): void =>{
    const value = e.target.value;
    this.setState({
      remarksText: value
    })
  }

  onStrokeEnd = (): void => {
    let hasSignatureInPad: boolean = false;
    if (this.state.signaturePadRef.current && !this.state.signaturePadRef.current.isEmpty()) {
      hasSignatureInPad = true;
    }
    this.setState({ hasSignatureInPad })
  }

  onSignatureError = (): void => {
    this.setState({ signatureError: true });
  }

  render() {
    return (
     
      <>
        <DriverSignature
          showHeader={this.props.type === 'do'}
          signaturePadRef={this.state.signaturePadRef} 
          saveSignature={this.saveSignature}
          clearSignature={this.clearSignature}
          isDisabledSave={this.isDisabledSave}
          onStrokeEnd={this.onStrokeEnd}
          confirmationType={this.props.return?'return':'delivery'}
          savedSignatureUrl={this.state.savedSignatureUrl}
          PONumber={this.props.match.params.number}
          type={this.props.type}
          awb={this.props.match.params.awbCode?`${this.props.match.params.awbCode}-${this.props.match.params.awbNumber}`:null}
          driverName={this.state.driverName}
          onSignatureError={this.onSignatureError}
          signatureError={this.state.signatureError}
          signaturePadWidth={this.state.signaturePadWidth}
          signaturePadHeight={this.state.signaturePadHeight}
          goodsValue={ this.state.goodsValue }
          updateGoodsValue={ this.updateGoodsValue }
          remarksText={ this.state.remarksText }
          handleRemarksChange={ this.handleRemarksChange }
        />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (message: string) => dispatch(receiveSuccess(message))
  };
};
  
export default connect(null, mapDispatchToProps)(DriverSignatureContainer);